import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Pencil2Icon } from "@radix-ui/react-icons";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useUserContext } from "@/contexts/userContext";
import { usePostChangeStrategyName } from "@/api/strategyApi";
import { toast } from "../ui/use-toast";
import { useTranslation } from "react-i18next";
import { usePatternUniverses } from "@/contexts/PatternUniverse";

const EditNameModal = ({ strategyData }: { strategyData: any }) => {
  const { user } = useUserContext();
  const [isOpen, setIsOpen] = useState<boolean>();
  const { mutateAsync: changeStrategyName } = usePostChangeStrategyName();
  const { t } = useTranslation("strategy-details");
  const { refetchScannerStrategies } = usePatternUniverses();

  const [strategyName, setStrategyName] = useState(strategyData?.label || "");

  const updateStrategyName = async () => {
    try {
      const response = await changeStrategyName({
        userId: user?.user_id ?? "",
        strategy_id: strategyData?.value,
        strategy_name: strategyName,
      });

      if (response.status === 200) {
        toast({ title: response.data.detail });
        refetchScannerStrategies(true, user?.user_id ?? "");
        setIsOpen(false);
      } else {
        toast({
          title: response.data.detail,
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Something went wrong",
        variant: "destructive",
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <div className="flex">
          <div>
            <Pencil2Icon className="ml-1 w-[20px] cursor-pointer" />
          </div>
        </div>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Edit scanner name")}</DialogTitle>
          <DialogDescription>
            <div className="mt-5">
              <h1>{t("Change name to:")}</h1>
              <Input
                className="mt-2"
                id="strategyName"
                autoComplete="off"
                type="text"
                name="strategyName"
                placeholder={t("strategyName")}
                value={strategyName}
                onChange={(e) => setStrategyName(e.target.value)}
              />
            </div>
            <div className="w-full flex mt-4 align-right justify-end">
              <div className="text-right">
                <Button onClick={updateStrategyName}>{t("Update")}</Button>
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};

export default EditNameModal;
